import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { _Deals_ } from "../../../Redux/Action/Action";
import { apiData } from "../../../actions";
import DataLoader from "../../../Utils/DataLoader";

export default function DealsCards() {
    const dispatch = useDispatch();

    const [dealsData, setDealsData] = useState([]);
    const [loader, setLoader] = useState(false);
    const [visibleCount, setVisibleCount] = useState(6); // for Load More

    const GetDeals = async () => {
        try {
            setLoader(true);
            const apiRes = await apiData.getDealsHome();

            if (apiRes?.status >= 200 && apiRes?.status <= 399) {
                setDealsData(
                    apiRes?.data?.data?.data?.travelExperienceProducts?.resultList || []
                );
            } else {
                console.error("Deals API error");
            }
        } catch (error) {
            console.error("Something went wrong while fetching deals", error);
        } finally {
            setLoader(false);
        }
    };

    useEffect(() => {
        GetDeals();
        dispatch(_Deals_());
    }, [dispatch]);

    const handleLoadMore = () => {
        setVisibleCount((prev) => prev + 6);
    };

    return (
        <section className="section-equal-padding deals_section uk-scrollspy-inview">
            <div className="container-fluid">
                <div className="row gy-4">
                    {loader && <p className="text-center"><DataLoader /></p>}

                    {!loader &&
                        dealsData?.slice(0, visibleCount)?.map((ele) => (
                            <div className="col-md-6 col-lg-4" key={ele?.id}>
                                <div className="resorts-box p-3 bg-white">
                                    <figure>
                                        <img
                                            loading="lazy"
                                            src={ele?.imageLink}
                                            alt={ele?.title}
                                            className="img-fluid"
                                        />
                                    </figure>

                                    <div className="resorts-content-box">
                                        <div className="resort-description pt-0">
                                            <h3>
                                                {ele?.title?.length > 25
                                                    ? `${ele.title.slice(0, 25)}...`
                                                    : ele?.title}
                                            </h3>

                                            <p>
                                                {ele?.description?.length > 80
                                                    ? `${ele.description.slice(0, 80)}...`
                                                    : ele?.description}
                                            </p>
                                        </div>

                                        <div className="d-flex justify-content-between align-items-center">
                                            <div className="price-label">
                                                <strong className="start_from_text">
                                                    Start From:
                                                </strong>{" "}
                                                $
                                                {ele?.salePrice?.amount ??
                                                    ele?.price?.amount ??
                                                    "N/A"}
                                            </div>
                                        </div>

                                        <div className="book-trip-btn mt-2">
                                            <a
                                                href={ele?.link}
                                                target="_blank"
                                                rel="noreferrer"
                                                className="w-auto"
                                            >
                                                Book Now
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                </div>

                {visibleCount < dealsData.length && (
                    <div className="d-flex justify-content-center mt-5">
                        <button className="view-all-btn w-auto" onClick={handleLoadMore}>
                            Load More
                        </button>
                    </div>
                )}
            </div>
        </section>
    );
}
